<template>
  <!-- 备品更换弹窗 -->
  <a-modal
    title="备品更换"
    :visible="visible"
    @ok="handleConfirm"
    @cancel="handleCancel"
    :confirmLoading="confirmLoading"
    width="520px"
  >
    <a-form>
      <a-form-item
        label="目标手环"
        :label-col="{ span: 6 }"
        :wrapper-col="{ span: 18 }"
      >
        <a-select
          v-model:value="targetWristbandId"
          placeholder="请选择"
          show-search
          :filter-option="filterWristbandOption"
          allow-clear
          :loading="optionsLoading"
          style="width: 100%"
        >
          <a-select-option
            v-for="wristband in wristbandOptions"
            :key="wristband.id"
            :value="wristband.id"
          >
            {{ wristband.mac || wristband.macAddress || wristband.name || '-' }}
          </a-select-option>
        </a-select>
      </a-form-item>
    </a-form>
    <div
      style="margin-top: 16px; color: #999; font-size: 12px; line-height: 1.5"
    >
      注:手环所绑定工作流、岗位名、员工id、对应项目将会导入目标手环本手环数据清空
    </div>
  </a-modal>
</template>

<script>
import { $on, $off, $once, $emit } from '../../../../utils/gogocodeTransfer'
/**
 * 备品更换弹窗组件
 * 功能：提供备品更换操作的选择界面
 * - 根据项目ID和手环ID获取可选手环列表（排除当前手环，且非定位环）
 * - 支持搜索和选择目标手环
 */
import {
  listSpareReplacementOptions,
  spareReplacement,
} from '@/api/system/wristband'

export default {
  name: 'SpareReplacementModal',
  props: {
    // 弹窗显示/隐藏状态
    visible: {
      type: Boolean,
      default: false,
    },
    // 当前手环ID（必填，用于排除）
    wristbandId: {
      type: [String, Number],
      default: null,
    },
    // 项目ID（必填，用于查询同项目的手环）
    projectId: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      // 目标手环ID
      targetWristbandId: undefined,
      // 手环选项列表
      wristbandOptions: [],
      // 手环选项加载状态
      optionsLoading: false,
      // 确认按钮加载状态
      confirmLoading: false,
    }
  },
  watch: {
    /**
     * 监听弹窗显示状态
     * 当弹窗打开时，加载手环列表
     */
    visible(newVal) {
      if (newVal) {
        this.targetWristbandId = undefined
        this.fetchWristbandOptions()
      } else {
        // 弹窗关闭时重置
        this.targetWristbandId = undefined
        this.wristbandOptions = []
      }
    },
  },
  methods: {
    /**
     * 获取手环选项列表
     * 根据项目ID获取手环列表（排除当前手环，且非定位环）
     */
    fetchWristbandOptions() {
      if (!this.projectId) {
        this.$message.warning('请先选择项目', 3)
        $emit(this, 'cancel')
        return
      }
      if (!this.wristbandId) {
        this.$message.warning('手环ID不能为空', 3)
        $emit(this, 'cancel')
        return
      }
      this.optionsLoading = true
      listSpareReplacementOptions({
        projectId: this.projectId,
        wristbandId: this.wristbandId,
      })
        .then((res) => {
          const list = res && res.data ? res.data : []
          this.wristbandOptions = Array.isArray(list) ? list : []
          // 如果没有数据，提示用户并关闭弹窗
          if (this.wristbandOptions.length === 0) {
            this.$message.warning('暂无更换的手环', 3)
            $emit(this, 'cancel')
          }
        })
        .catch(() => {
          this.wristbandOptions = []
          this.$message.error('获取手环列表失败', 3)
          $emit(this, 'cancel')
        })
        .finally(() => {
          this.optionsLoading = false
        })
    },

    /**
     * 本地过滤手环选项
     */
    filterWristbandOption(input, option) {
      if (
        !option ||
        !option.componentOptions ||
        !option.componentOptions.children
      ) {
        return false
      }
      const text = option.componentOptions.children
        .map((child) => child.text || (child.elm && child.elm.innerText) || '')
        .join('')
        .toLowerCase()
      return text.includes((input || '').toLowerCase())
    },

    /**
     * 确认操作
     * 验证选择后发出确认事件
     */
    handleConfirm() {
      if (!this.targetWristbandId) {
        this.$message.warning('请选择目标手环', 3)
        return
      }
      if (!this.wristbandId) {
        this.$message.warning('当前手环ID不能为空', 3)
        return
      }
      this.confirmLoading = true
      spareReplacement({
        sourceWristbandId: this.wristbandId,
        targetWristbandId: this.targetWristbandId,
      })
        .then(() => {
          const target = this.wristbandOptions.find(
            (item) => String(item.id) === String(this.targetWristbandId)
          )
          this.$message.success('备品更换成功', 3)
          $emit(this, 'confirm', {
            sourceWristbandId: this.wristbandId,
            targetWristbandId: this.targetWristbandId,
            targetWristbandMac: target ? target.mac : undefined,
          })
          this.handleCancel()
        })
        .catch(() => {
          this.$message.error('备品更换失败，请稍后重试', 3)
        })
        .finally(() => {
          this.confirmLoading = false
        })
    },

    /**
     * 取消操作
     * 关闭弹窗并重置表单
     */
    handleCancel() {
      this.targetWristbandId = undefined
      this.wristbandOptions = []
      $emit(this, 'cancel')
    },
  },
  emits: ['confirm', 'cancel'],
}
</script>
